import useDebounce from 'hooks/useDebounce';
import { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import { useSearchAddress } from 'services';

const CustomSearchAddress = ({
	selectProps,
	fieldValue,
	onBlur,
	handleInputChange,
	isClearable = false,
	type = '',
}: any) => {
	// state
	const [addressQry, setAddressQry] = useState<string | null>(fieldValue || null);
	const [menuIsOpen, setMenuIsOpen] = useState<boolean>(false);

	// hooks
	const debouncedQry = useDebounce(addressQry, 300);

	// query
	const { data: addressData = [], refetch } = useSearchAddress({
		keyword: debouncedQry,
		type: false,
	});
	useEffect(() => {
		if (debouncedQry) {
			refetch();
		}
	}, [debouncedQry]);

	return (
		<ReactSelect
			{...selectProps}
			isSearchable
			isClearable={isClearable}
			{...(type === 'profileLocation'
				? { inputValue: addressQry || '' }
				: { defaultInputValue: fieldValue })}
			defaultInputValue={fieldValue}
			options={addressData}
			getOptionValue={(option: any) => option.location}
			getOptionLabel={(option: any) => option.location}
			onInputChange={(value: string) => {
				if (type === 'profileLocation') {
					if (value || addressQry?.length === 1) {
						setAddressQry(value);
						setMenuIsOpen(true);
						handleInputChange(value);
					}
				} else {
					setAddressQry(value);
					setMenuIsOpen(true);
				}
			}}
			onBlur={onBlur}
			value={addressData?.find((addressObj: any) => addressObj.location === fieldValue)}
			autoFocus={false}
			className="form-react-select"
			classNamePrefix="select"
			menuIsOpen={menuIsOpen}
			onMenuClose={() => setMenuIsOpen(false)}
		/>
	);
};

export default CustomSearchAddress;
